import type { ReactNode } from 'react';
import { AxiosErrorBoundary, Popover } from 'ui';
import type { ContentEvent } from '../calendar-layout-content';
import { NodeEvent } from './node-event';
import { RailsEvent } from './rails-event';

type P = {
  children: ReactNode;
  eventId: string;
  getPathToEventDetail: (id: string) => string;
  navigateToEventDetail: (id: string) => Promise<void>;
  type: ContentEvent['type'];
};

const Event = ({ children, eventId, getPathToEventDetail, navigateToEventDetail, type }: P) => (
  // TODO: In EventCalendar day/week, put the positioned event div outside renderEvent (like month `.day-event`), then drop this div.
  // This div is getPopupContainer's parent so the open popover sits next to this event in the DOM so Tab goes event → popover → next event. Without it, day/week mount the popup after all events in the column.
  <div>
    <Popover
      classNames={{ container: 'calendar-event-popover-container', root: 'calendar-event-popover' }}
      content={
        <AxiosErrorBoundary actions={false}>
          {type === 'node' ? (
            <NodeEvent
              eventId={eventId}
              getPathToEventDetail={getPathToEventDetail}
              navigateToEventDetail={navigateToEventDetail}
            />
          ) : (
            <RailsEvent eventId={eventId} getPathToEventDetail={getPathToEventDetail} />
          )}
        </AxiosErrorBoundary>
      }
      getPopupContainer={(triggerNode) => triggerNode.parentElement ?? document.body}
      trigger="click"
    >
      {children}
    </Popover>
  </div>
);

export default Event;
